<!-- In the chat window's frame (src/_cura-window.scss, panel class ai-recording-panel), as the
     recording dialog is. -->
<div class="cw-header">
    <mat-icon class="kind">download</mat-icon>
    <div class="title">
        <span class="name">Recordings for {{ patient.name }} {{ patient.surname }}</span>
        <span class="subtitle">Download the audio recorded on a day</span>
    </div>
</div>
<div mat-dialog-content class="cw-body">
    <div class="cw-processing" *ngIf="loading">
        <mat-spinner diameter="24"></mat-spinner>
        <span>Looking for recordings…</span>
    </div>
    <div class="cw-status error" *ngIf="error">{{ error }}</div>
    <ul class="recording-days" *ngIf="!loading && !error">
        <li *ngFor="let date of dates">
            <span class="day">{{ date }}</span>
            <button mat-stroked-button class="quiet-button" (click)="download(date)" [disabled]="downloading">
                <mat-icon>download</mat-icon>Download
            </button>
        </li>
    </ul>
    <p class="cw-hint" *ngIf="!loading && !error && !dates?.length">No recordings are kept for this patient.</p>
</div>
<div mat-dialog-actions class="cw-actions">
    <span class="spacer"></span>
    <button mat-stroked-button class="quiet-button" (click)="close()">Close</button>
</div>
